import { RiSearchLine, RiCloseLine } from 'react-icons/ri';
import type { Company } from '../../models/interview';
import { cn } from '../../utils/cn';

interface CompanySearchInputProps {
    value: string | Company;
    onChange: (company: Company | string) => void;
    placeholder?: string;
    className?: string;
}

/**
 * Plain company name input. Previously searched OpenCorporates for
 * autocomplete, but that requires a paid API key we don't have — free
 * anonymous access is deprecated and every request was CORS-blocked.
 */
export default function CompanySearchInput({ value, onChange, placeholder, className }: CompanySearchInputProps) {
    const text = typeof value === 'string' ? value : value?.name || '';

    return (
        <div className={cn("relative z-20", className)}>
            <input
                type="text"
                value={text}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
                className="w-full bg-black/20 border border-white/10 rounded-xl pl-10 pr-10 py-3 text-white placeholder:text-gray-600 focus:border-white/30 outline-none transition-colors"
            />

            <RiSearchLine className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-500" size={18} />

            {text && (
                <button
                    onClick={() => onChange('')}
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-white transition-colors"
                >
                    <RiCloseLine size={18} />
                </button>
            )}
        </div>
    );
}
